"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mediaTypeAdapter_1 = require("../adapters/mediaTypeAdapter");
var getAllMediaKeys_1 = require("./getAllMediaKeys");
var MarketerNames = (function () {
    function MarketerNames() {
    }
    MarketerNames.prototype.getMarketerIds = function (medium) {
        if (medium && medium.infos) {
            if (medium.infos["PublisherID_Main"] && medium.infos["PublisherID_Main"] !== "") {
                return [medium.infos["PublisherID_Main"]];
            }
            var i = 1;
            var resultArray = new Array();
            while (true) {
                var candidate = "PublisherID_Main_" + i;
                var mediumInfos = medium.infos[candidate];
                if (mediumInfos) {
                    resultArray.push(mediumInfos);
                }
                else {
                    break;
                }
                i++;
            }
            return resultArray;
        }
        return [];
    };
    MarketerNames.setMultipleMarketersInfos = function (row) {
        _.set(row, "conditions.online.contact.fullName", "Mehrere Vermarkter");
        _.set(row, "conditions.online.contact.phone", "");
    };
    MarketerNames.getMarketerArray = function (marketerIds, marketerMap) {
        var marketerArray = new Array();
        marketerIds.forEach(function (id) {
            var theCurrentMarketerId = _.find(marketerMap, (function (marketer) { return marketer.id === id; }));
            if (theCurrentMarketerId) {
                marketerArray.push(theCurrentMarketerId.name);
            }
        });
        return marketerArray;
    };
    MarketerNames.prototype.update = function (context, thisContext, rows) {
        var _this = this;
        var mediaTypeConverter = new mediaTypeAdapter_1.MediaTypeConverter();
        var mediaKeys = getAllMediaKeys_1.getAllMediaKeys(context.plan.mediumGroups);
        return context.getMedia(mediaKeys).then(function (mediaMap) {
            var marketerIds = new Array();
            var theMediaKeys = Object.keys(mediaMap);
            theMediaKeys.forEach(function (key) {
                var item = mediaMap[key];
                var candidateMediumIds = _this.getMarketerIds(item);
                marketerIds = marketerIds.concat(candidateMediumIds);
            });
            return context.getMarketers(marketerIds).then(function (marketerMap) {
                var mergeMarketer = function (row) {
                    var medium = row["medium"];
                    if (!medium.key) {
                        return row;
                    }
                    var mediumFromMediaMap = _.find(mediaMap, function (theMedium) { return theMedium.key === medium.key; });
                    var infoObject = _.get(mediumFromMediaMap, "infos");
                    var mediumType = mediaTypeConverter.getType(infoObject);
                    var thisMarketerIds = _this.getMarketerIds(mediumFromMediaMap);
                    var theMarketerArray = MarketerNames.getMarketerArray(thisMarketerIds, marketerMap);
                    var theMarketerName = theMarketerArray.join(", ");
                    if (thisMarketerIds.length > 1) {
                        MarketerNames.setMultipleMarketersInfos(row);
                    }
                    return _.assign({}, row, { marketerName: theMarketerName, mediumType: mediumType });
                };
                if (context === thisContext) {
                    return rows.map(mergeMarketer);
                }
                return rows;
            });
        });
    };
    return MarketerNames;
}());
exports.MarketerNames = MarketerNames;
//# sourceMappingURL=marketerNames.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/posterControllerSupportingClasses/marketerNames.js
// module id = 64
// module chunks = 0